import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import {
  EmailSenderSettingsDto,
  UpdateEmailSenderSettingsRequest,
} from '@/features/dashboard/emailSender/types/EmailSenderSettingsDto.ts';

const emailSenderApi = {
  get: async (): Promise<EmailSenderSettingsDto> => {
    return await fetchPrivateApi<EmailSenderSettingsDto>(
      'GET',
      'settings/email-sender',
    );
  },
  set: async (
    request: UpdateEmailSenderSettingsRequest,
  ): Promise<EmailSenderSettingsDto> => {
    return await fetchPrivateApi<EmailSenderSettingsDto>(
      'PUT',
      'settings/email-sender',
      request,
    );
  },
};

export default emailSenderApi;
